import type { BookingMessages } from "@/i18n/types";
import { de } from "@/i18n/de";

const ARRIVAL_TYPE_LABELS: Record<string, string> = {
  motorhome: de.guestPortalVehicle.motorhome,
  caravan: de.guestPortalVehicle.caravan,
  tent_car: de.guestPortalVehicle.tent_car,
  tent_bike: de.guestPortalVehicle.tent_bike,
};

export function getGuestPortalVehicleLabels(
  messages: BookingMessages,
): Record<string, string> {
  return { ...messages.guestPortalVehicle };
}

export function arrivalTypeLabel(code: string | null | undefined): string {
  if (!code) return "–";
  return ARRIVAL_TYPE_LABELS[code] ?? code;
}

export function periodLabelBadgeClass(label: string): string {
  switch (label) {
    case "kommend":
      return "bg-sky-100 text-sky-800";
    case "aktuell":
      return "bg-emerald-100 text-emerald-800";
    case "storniert":
      return "bg-red-100 text-red-800";
    default:
      return "bg-slate-100 text-slate-700";
  }
}

export function periodLabelText(label: string): string {
  const map: Record<string, string> = {
    kommend: de.guestPortalVehicle.kommend,
    aktuell: de.guestPortalVehicle.aktuell,
    vergangen: de.guestPortalVehicle.vergangen,
    storniert: de.guestPortalVehicle.storniert,
  };
  return map[label] ?? label;
}
